<div class="weekly-hours-page">
  <div class="page-header">
    <div>
      <h1>Relevés d'heures</h1>
      <p class="subtitle">Relevés générés automatiquement par établissement — hebdomadaires ou mensuels selon la configuration. Chaque fonction a son propre relevé : une ligne Médecins et une ligne Infirmiers.</p>
    </div>
    <button class="btn-refresh" (click)="load()" [disabled]="loading">
      Rafraîchir
    </button>
  </div>

  <!-- E1 (client clinique — P5) : paramètres du relevé — périodicité + e-mail comptable -->
  @if (config) {
    <div class="config-section">
      <h3>Paramètres du relevé</h3>
      <div class="config-row">
        <label>Périodicité :</label>
        <select [(ngModel)]="config.frequency" [disabled]="savingConfig">
          <option value="WEEKLY">Hebdomadaire</option>
          <option value="MONTHLY">Mensuel</option>
        </select>
        <label class="ms-3">E-mail comptable :</label>
        <input type="email" [(ngModel)]="config.accountantEmail"
               placeholder="comptable@exemple.fr" [disabled]="savingConfig" />
        <button class="btn-save-config" (click)="saveConfig()" [disabled]="savingConfig">
          {{ savingConfig ? 'Enregistrement...' : 'Enregistrer' }}
        </button>
      </div>
      <p class="config-hint">
        Le relevé est envoyé à l'e-mail comptable s'il est renseigné, sinon à l'établissement.
        En mensuel, un seul relevé par fonction (Médecins, Infirmiers) couvre tout le mois précédent et peut être envoyé dès le 1er du mois suivant.
      </p>
    </div>
  }

  <!-- E4 (client clinique — P5) : relevés d'heures envoyés par les pros — à valider -->
  <div class="validations-section">
    <h3>Relevés d'heures des professionnels — à valider ({{ submissions.length }})</h3>
    @if (submissionsLoading) {
      <div class="empty-state">Chargement...</div>
    } @else if (submissions.length === 0) {
      <div class="empty-state">Aucun relevé en attente de validation.</div>
    } @else {
      <div class="reports-table">
        <div class="table-row table-head">
          <div>Mission</div>
          <div>Professionnel</div>
          <div>Période</div>
          <div>Jours</div>
          <div>Actions</div>
        </div>
        @for (s of submissions; track s.missionId) {
          <div class="table-row table-data" (click)="openSubmission(s)">
            <div>{{ s.missionRef }}</div>
            <div>{{ s.candidatFullname || '—' }}</div>
            <div>
              @if (s.startDate) {
                {{ s.startDate | date:'dd/MM/yy' }} → {{ s.endDate | date:'dd/MM/yy' }}
              } @else { — }
            </div>
            <div>{{ s.dayCount }}</div>
            <div class="actions" (click)="$event.stopPropagation()">
              <button class="btn btn-secondary btn-sm" (click)="openSubmission(s)">
                Détail / Éditer
              </button>
              <button class="btn btn-primary btn-sm"
                [disabled]="validatingId === s.missionId"
                (click)="quickValidate(s, $event)">
                {{ validatingId === s.missionId ? '...' : 'Valider' }}
              </button>
            </div>
          </div>
        }
      </div>
    }
  </div>

  @if (loading) {
    <div class="empty-state">Chargement...</div>
  } @else if (reports.length === 0) {
    <div class="empty-state">Aucun relevé disponible pour le moment.</div>
  } @else {
    <!-- Correction client (P5) : un relevé par fonction — une ligne Médecins, une ligne Infirmiers -->
    <div class="reports-table by-fonction">
      <div class="table-row table-head">
        <div>Établissement</div>
        <div>Fonction</div>
        <div>Période</div>
        <div>Statut</div>
        <div>Actions</div>
      </div>
      @for (r of reports; track r.id) {
        <div class="table-row table-data" (click)="open(r)">
          <div class="etab-name">{{ r.etablissementName }}</div>
          <div>
            <span class="fonction-pill"
              [class.medecins]="r.typeSecteurId === 1"
              [class.infirmiers]="r.typeSecteurId === 2">
              {{ r.fonctionLabel || 'Médecins + Infirmiers' }}
            </span>
          </div>
          <div class="period">
            <strong>{{ r.periodLabel || ('Semaine ' + r.weekNumber) }}</strong>
            <div class="period-dates">{{ r.weekStart | date:'dd/MM/yy' }} → {{ r.weekEnd | date:'dd/MM/yy' }}</div>
          </div>
          <div>
            <span class="status-pill" [class.draft]="r.status === 'DRAFT'"
              [class.ready]="r.status === 'READY'"
              [class.sent]="r.status === 'SENT'">
              {{ statusLabel(r.status) }}
              @if (r.status === 'SENT') { <span>✓</span> }
            </span>
          </div>
          <div class="actions" (click)="$event.stopPropagation()">
            <button class="btn btn-secondary btn-sm" (click)="open(r); $event.stopPropagation()">
              Voir / Éditer
            </button>
            @if (r.canSendNow) {
              <button class="btn btn-primary btn-sm"
                [disabled]="sendingId === r.id"
                (click)="send(r, $event)">
                {{ sendingId === r.id ? 'Envoi...' : 'Envoyer' }}
              </button>
            } @else if (r.status !== 'SENT') {
              <span class="not-yet" [tooltip]="'Disponible à partir du ' + (r.allowedSendFrom | date:'dd/MM HH:mm')">
                ⏳
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
